import jwtDecode from "jwt-decode";

export const set = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
  return get(key)
}

export const get = key => {
  let retorno = JSON.parse(sessionStorage.getItem(key))
  return retorno
}

export const getUser = () => {
  const token = sessionStorage.getItem('authSistema');
  const user = jwtDecode(token);
  if (!user) return undefined
  return user
}

export const clear = key => {
  sessionStorage.clear()
}